/**
 * Created by Dhanya Akhil on 3/1/2017.
 */
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {CanActivateViaAuthGuard} from '../../shared/services/auth.service';
import {PasswordComponent} from "./components/password.component";

const routes = [{
              path:'password',
              component:PasswordComponent,
              canActivate:[CanActivateViaAuthGuard]
            }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class PasswordRoutingModule { }
